import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <img src="/mercadobulk-bag.svg" alt="MercadoBulk" className="h-16 w-16 shrink-0" />
      </div>

      {/* App Title */}
      <h1 className="text-3xl font-semibold text-text-primary mb-2">
        MercadoBulk
      </h1>

      {/* Welcome Message */}
      <div className="space-y-2">
        <p className="text-text-secondary">
          Inicia sesión para gestionar tus productos en MercadoBulk
        </p>
      </div>

      {/* Features Highlight */}
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
        <div className="flex items-center justify-center space-x-2 text-text-secondary">
          <Icon name="Upload" size={16} className="text-primary" />
          <span>Carga Masiva</span>
        </div>
        <div className="flex items-center justify-center space-x-2 text-text-secondary">
          <Icon name="Zap" size={16} className="text-primary" />
          <span>Automatización</span>
        </div>
        <div className="flex items-center justify-center space-x-2 text-text-secondary">
          <Icon name="BarChart3" size={16} className="text-primary" />
          <span>Análisis</span>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;